import i18n from "@/libs/i18n/i18n";

export default [
  {
    title: i18n.t("navigation.homePage"),
    route: "home",
    icon: "house",
    resource: "dashboard",
    action: "read",
  },
  // {
  //   title: i18n.t("navigation.unitAdmission"),
  //   route: "",
  //   icon: "receipt",
  //   children: [
  //     {
  //       title: i18n.t("navigation.admission"),
  //       route: "preAdmissionSearch",
  //       resource: "patients",
  //       action: "reception",
  //     },
  //     {
  //       title: i18n.t("navigation.todayReceptions"),
  //       route: "todayReceptions",
  //       resource: "patients",
  //       action: "todayReceptions",
  //     },
  //   ],
  // },
  // {
  //   title: i18n.t("navigation.cardboardAdmission"),
  //   route: "cardboardAdmission",
  //   icon: "box",
  //   resource: "patients",
  //   action: "cardboard",
  // },
  {
    title: i18n.t("navigation.usersList"),
    route: "manageUsers",
    icon: "people-fill",
    resource: "users",
    action: "read",
  },
  {
    title: i18n.t("navigation.doctorsList"),
    route: "manageDoctors",
    icon: "people",
    resource: "doctors",
    action: "read",
  },
  {
    title: i18n.t("navigation.patientsList"),
    route: "managePatients",
    icon: "people",
    resource: "patients",
    action: "read",
  },
  {
    title: i18n.t("navigation.calendar"),
    route: "manageCalendar",
    icon: "command",
    resource: "calendar",
    action: "read",
  },
  {
    title: i18n.t("navigation.AppointmentOfPatients"),
    route: "manageAppointmentOfPatients",
    icon: "people-fill",
    resource: "AppointmentOfPatients",
    action: "read",
  },
  {
    title: i18n.t("navigation.message"),
    route: "manageMessages",
    resource: "message",
    action: "read",
    icon: "envelope",
  },
  {
    title: i18n.t("navigation.baseInformation"),
    route: "structure",
    resource: "structure",
    action: "read",
    children: [
      {
        title: i18n.t("navigation.section"),
        route: "manageSection",
        icon: "command",
        resource: "sections",
        action: "read",
      },
      {
        title: i18n.t("navigation.unit"),
        route: "manageUnit",
        icon: "columns",
        resource: "units",
        action: "read",
      },
      {
        title: i18n.t("navigation.medicalSpecialties"),
        route: "manageMedicalSpecialties",
        resource: "medicalSpecialties",
        action: "read",
        icon: "command",
      },
    ],
  },
  {
    title: i18n.t("navigation.HolidaysMenu"),
    route: "manageHolidays",
    icon: "Book",
    resource: "holidays",
    action: "read",
  },
  {
    title: i18n.t("navigation.permission"),
    route: "",
    icon: "file-text",
    children: [
      {
        title: i18n.t("navigation.permissionGroups"),
        route: "managePermissionGroups",
      },
      {
        title: i18n.t("navigation.permissions"),
        route: "managePermissions",
        resource: "permissions",
        action: "read",
      },
    ],
  },
  {
    title: i18n.t("navigation.settings"),
    route: "manageSettings",
    icon: "command",
    resource: "settings",
    action: "read",
  },

  //   title: i18n.t("navigation.sectionsManagement"),
  //   route: "receptionSections",
  //   icon: "receipt",
  //   resource: "receptionSections",
  //   action: "read",
  // },
  // {
  //   title: i18n.t("navigation.centralCashier"),
  //   route: "manageCentralCashier",
  //   icon: "receipt",
  //   resource: "centralCashier",
  //   action: "read",
  // },
  // {
  //   title: i18n.t("navigation.accounting"),
  //   route: "",
  //   icon: "credit-card",
  //   children: [
  //     {
  //       title: i18n.t("navigation.banks"),
  //       route: "manageBanks",
  //       resource: "banks",
  //       action: "read",
  //     },
  //     {
  //       title: i18n.t("navigation.pos"),
  //       route: "managePose",
  //       resource: "pose",
  //       action: "read",
  //     },
  //     {
  //       title: i18n.t("navigation.bankCards"),
  //       route: "manageBankCards",
  //       resource: "bank-cards",
  //       action: "read",
  //     },
  //     {
  //       title: i18n.t("navigation.discountGroups"),
  //       route: "manageDiscountGroups",
  //       resource: "discountGroups",
  //       action: "read",
  //     },
  //     {
  //       title: i18n.t("navigation.currency"),
  //       route: "manageCurrencies",
  //       icon: "globe",
  //       resource: "currencies",
  //       action: "read",
  //     },
  //     {
  //       title: i18n.t("navigation.financialSettings"),
  //       route: "configs",
  //       icon: "sliders",
  //       resource: "financialConfigs",
  //       action: "read",
  //     },
  //     {
  //       title: i18n.t("navigation.accountingDocuments"),
  //       route: "accountingDocumentsList",
  //       resource: "accountingDocuments",
  //       action: "read",
  //     },
  //     {
  //       title: i18n.t("navigation.accountsHeadings"),
  //       route: "accountsHeading",
  //       resource: "accountsHeading",
  //       action: "read",
  //       children: [
  //         {
  //           title: i18n.t("navigation.accountGroups"),
  //           route: "manageAccountGroup",
  //           resource: "accountGroups",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.totalAccounts"),
  //           route: "manageTotalAccount",
  //           resource: "totalAccount",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.subsidiaryAccounts"),
  //           route: "manageSubsidiaryAccount",
  //           resource: "subsidiaryAccount",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.detailAccount"),
  //           route: "manageDetailAccount",
  //           resource: "detailAccount",
  //           action: "read",
  //         },
  //       ],
  //     },

  //     {
  //       title: i18n.t("navigation.reports"),
  //       route: "",
  //       icon: "file-text",
  //       children: [
  //         //         {
  //         //             title: i18n.t('navigation.financialReports'),
  //         //             route: 'financialReports',
  //         //         },
  //         //         {
  //         //             title: i18n.t('navigation.functionalReports'),
  //         //             route: 'functionalReports',
  //         //             children: [
  //         {
  //           title: i18n.t("navigation.doctorReport"),
  //           route: "doctorReport",
  //           resource: "financialReportDoctors",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.cashierReport"),
  //           route: "cashierReport",
  //           resource: "financialReportCashiers",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.returnReport"),
  //           route: "returnReport",
  //           resource: "financialReportReturns",
  //           action: "read",
  //         },
  //         // ]
  //         // },
  //       ],
  //     },
  //   ],
  // },
  // {
  //   title: i18n.t("navigation.baseInformation"),
  //   route: "baseInfo",
  //   icon: "check-square",

  //   children: [
  //     {
  //       title: i18n.t("navigation.medicalRecords"),
  //       route: "medicalRecords",
  //       resource: "medicalRecords",
  //       action: "read",
  //       children: [
  //         {
  //           title: i18n.t("navigation.sonographyForms"),
  //           route: "",
  //           children: [
  //             {
  //               title: i18n.t("navigation.indications"),
  //               route: "manageIndications",
  //               resource: "indications",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.MedicalAbbreviationTests"),
  //               route: "manageMedicalAbbreviationTests",
  //               resource: "medicalAbbreviationTests",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.examinationMethods"),
  //               route: "manageExaminationMethods",
  //               resource: "examinationMethods",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.examinationViews"),
  //               route: "manageExaminationViews",
  //               resource: "examinationViews",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.cardiacActivities"),
  //               route: "manageCardiacActivities",
  //               resource: "cardiacActivities",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.placentaLocations"),
  //               route: "managePlacentaLocations",
  //               resource: "placentaLocations",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.impressionLocations"),
  //               route: "manageImpressionLocations",
  //               resource: "impressionLocations",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.bladderNodules"),
  //               route: "manageBladderNodules",
  //               resource: "bladderNodules",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.uterusPositions"),
  //               route: "manageUterusPositions",
  //               resource: "uterusPositions",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.uterusSizes"),
  //               route: "manageUterusSizes",
  //               resource: "uterusSizes",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.uterusAdenomyosisTests"),
  //               route: "manageUterusAdenomyosisTests",
  //               resource: "uterusAdenomyosisTests",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.endometriumTests"),
  //               route: "manageEndometriumTests",
  //               resource: "endometriumTests",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.endometriumTypes"),
  //               route: "manageEndometriumTypes",
  //               resource: "endometriumTypes",
  //               action: "read",
  //             },
  //             {
  //                 title: i18n.t('navigation.endometriumIsoTests'),
  //                 route: 'manageEndometriumIsoTests',
  //                 resource: 'endometriumTypes',
  //                 action:'read'
  //             },
  //             {
  //               title: i18n.t("navigation.fibroidTypes"),
  //               route: "manageFibroidTypes",
  //               resource: "fibroidTypes",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.polypTypes"),
  //               route: "managePolypTypes",
  //               resource: "polypTypes",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.threeDCoronals"),
  //               route: "manageThreeDCoronals",
  //               resource: "threeDCoronals",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.threeDCoronalViews"),
  //               route: "manageThreeDCoronalViews",
  //               resource: "threeDCoronalViews",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.endometriomaTypes"),
  //               route: "manageEndometriomaTypes",
  //               resource: "endometriomaTypes",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.ovarianAdhesionTypes"),
  //               route: "manageOvarianAdhesionTypes",
  //               resource: "ovarianAdhesionTypes",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.dopplerStudyTypes"),
  //               route: "manageDopplerStudyTypes",
  //               resource: "dopplerStudyTypes",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.pouchDouglasTypes"),
  //               route: "managePouchDouglasTypes",
  //               resource: "pouchDouglasTypes",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.uteroSacralLigamentNoduleTypes"),
  //               route: "manageUteroSacralLigamentNoduleTypes",
  //               resource: "uteroSacralLigamentNoduleTypes",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.rectoSigmoidNoduleTypes"),
  //               route: "manageRectoSigmoidNoduleTypes",
  //               resource: "rectoSigmoidNoduleTypes",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.tendernessWithTheProbeTypes"),
  //               route: "manageTendernessWithTheProbeTypes",
  //               resource: "tendernessWithTheProbeTypes",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.commentTypes"),
  //               route: "manageCommentTypes",
  //               resource: "commentTypes",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.adnexaTypes"),
  //               route: "manageAdnexaTypes",
  //               resource: "adnexaTypes",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.gestationalSacTypes"),
  //               route: "manageGestationalSacTypes",
  //               resource: "gestationalSacTypes",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.gestationalLocationTypes"),
  //               route: "manageGestationalLocationTypes",
  //               resource: "gestationalLocationTypes",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.yolkSacTypes"),
  //               route: "manageYolkSacTypes",
  //               resource: "yolkSacTypes",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.embryoSonographicTypes"),
  //               route: "manageEmbryoSonographicTypes",
  //               resource: "embryoSonographicTypes",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.bothOvariesTypes"),
  //               route: "manageBothOvariesTypes",
  //               resource: "bothOvariesTypes",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.planAndFollowUpTypes"),
  //               route: "managePlanAndFollowUpTypes",
  //               resource: "planAndFollowUpTypes",
  //               action: "read",
  //             },
  //             {
  //               title: i18n.t("navigation.freeFluidTypes"),
  //               route: "manageFreeFluidTypes",
  //               resource: "freeFluidTypes",
  //               action: "read",
  //             },
  //           ],
  //         },
  //         {
  //           title: i18n.t("navigation.contraceptives"),
  //           route: "manageContraceptives",
  //           resource: "contraceptives",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.diseases"),
  //           route: "manageDiseases",
  //           resource: "diseases",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.cancers"),
  //           route: "manageCancers",
  //           resource: "cancers",
  //           action: "read",
  //         },
  //         // {
  //         //     title: i18n.t('navigation.radiologyTests'),
  //         //     route: 'manageRadiologyTests',
  //         //     resource: 'radiologyTests',
  //         //     action:'read'
  //         // },
  //         {
  //           title: i18n.t("navigation.medications"),
  //           route: "manageMedications",
  //           resource: "medications",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.pregnancyMethods"),
  //           route: "managePregnancyMethods",
  //           resource: "pregnancyMethods",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.parityTypes"),
  //           route: "manageParityTypes",
  //           resource: "parityTypes",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.abortionTypes"),
  //           route: "manageAbortionTypes",
  //           resource: "abortionTypes",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.abortionCauses"),
  //           route: "manageAbortionCauses",
  //           resource: "abortionCause",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.abortionMethods"),
  //           route: "manageAbortionMethods",
  //           resource: "abortionMethods",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.ivfMethods"),
  //           route: "manageIvfMethods",
  //           resource: "ivfMethods",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.transferOperationTypes"),
  //           route: "manageTransferOperationTypes",
  //           resource: "transferOperationTypes",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.ioMethods"),
  //           route: "manageIoMethods",
  //           resource: "ioMethods",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.allergies"),
  //           route: "manageAllergies",
  //           resource: "allergies",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.addictions"),
  //           route: "manageAddictions",
  //           resource: "addictions",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.cyclePains"),
  //           route: "manageCyclePains",
  //           resource: "cyclePains",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.urologyTests"),
  //           route: "manageUrologyTests",
  //           resource: "urologyTests",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.artificialReproductiveTechnologies"),
  //           route: "manageArtificialReproductiveTechnologies",
  //           resource: "artificial-reproductive-technologies",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.reasonOfReferences"),
  //           route: "manageReasonOfReferences",
  //           resource: "reasonOfReference",
  //           action: "read",
  //         },
  //       ],
  //     },
  //     {
  //       title: i18n.t("navigation.userRelated"),
  //       route: "userRelated",
  //       resource: "userRelated",
  //       action: "read",
  //       children: [
  //         {
  //           title: i18n.t("navigation.medicalSpecialties"),
  //           route: "manageMedicalSpecialties",
  //           resource: "medicalSpecialties",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.medicalScientificDegrees"),
  //           route: "manageMedicalScientificDegrees",
  //           resource: "medicalScientificDegrees",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.familyRelationships"),
  //           route: "manageFamilyRelationships",
  //           resource: "familyRelationships",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.bloodTypes"),
  //           route: "manageBloodTypes",
  //           resource: "bloodTypes",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.socialNetworks"),
  //           route: "manageSocialNetworks",
  //           resource: "socialNetworks",
  //           action: "read",
  //         },
  //       ],
  //     },
  //     {
  //       title: i18n.t("navigation.structure"),
  //       route: "structure",
  //       resource: "structure",
  //       action: "read",
  //       children: [
  //         {
  //           title: i18n.t("navigation.unit"),
  //           route: "manageUnit",
  //           icon: "columns",
  //           resource: "units",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.room"),
  //           route: "manageRoom",
  //           icon: "square",
  //           resource: "rooms",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.bed"),
  //           route: "manageBed",
  //           icon: "grid",
  //           resource: "beds",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.section"),
  //           route: "manageSection",
  //           icon: "command",
  //           resource: "sections",
  //           action: "read",
  //         },
  //       ],
  //     },
  //     {
  //       title: i18n.t("navigation.service"),
  //       route: "",
  //       resource: "service",
  //       action: "read",
  //       children: [
  //         {
  //           title: i18n.t("navigation.services"),
  //           route: "manageServices",
  //           resource: "services",
  //           action: "read",
  //         },

  //         {
  //           title: i18n.t("navigation.serviceGroups"),
  //           route: "manageServiceGroups",
  //           resource: "serviceGroups",
  //           action: "read",
  //         },
  //         {
  //           title: i18n.t("navigation.serviceCategories"),
  //           route: "manageServiceCategories",
  //           resource: "serviceCategories",
  //           action: "read",
  //         },
  //       ],
  //     },
  //     // {
  //     //     title: i18n.t('navigation.countryDivisions'),
  //     //     route: '',
  //     //     resource: 'dashboard',
  //     //     action:'read',
  //     //     children: [
  //     //         {
  //     //             title: i18n.t('navigation.countries'),
  //     //             route: 'manageCountries',
  //     //             resource: 'dashboard',
  //     //             action:'read',
  //     //         },
  //     //
  //     //         {
  //     //             title: i18n.t('navigation.provinces'),
  //     //             route: 'manageProvinces',
  //     //             resource: 'dashboard',
  //     //             action:'read',
  //     //         },
  //     //         {
  //     //             title: i18n.t('navigation.cities'),
  //     //             route: 'manageCities',
  //     //             resource: 'dashboard',
  //     //             action:'read',
  //     //         },
  //     //     ]
  //     // },
  //   ],
  // },
  // {
  //   title: i18n.t("navigation.reports"),
  //   route: "",
  //   icon: "file-text",
  //   children: [
  //     // {
  //     //     title: i18n.t('navigation.financialReports'),
  //     //     route: 'financialReports',
  //     // },
  //     // {
  //     //   title: i18n.t("navigation.functionalReports"),
  //     //   route: "",
  //     //   children: [
  //     {
  //       title: i18n.t("navigation.unitReport"),
  //       route: "unitReport",
  //       resource: "report",
  //       action: "unitsReport",
  //     },
  //     //   ],
  //     // },
  //   ],
  // },
  {
    title: i18n.t("navigation.turnCounter"),
    route: "manageturnCounter",
    icon: "receipt",
    resource: "turnCounter",
    action: "read",
  },
];
